import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import Button from "../../components/ui/Button";
import ScrollReveal from "../../components/animations/ScrollReveal";

const points = [
  {
    title: "End-to-end solutions",
    desc: "From strategy to execution, we handle the full journey so you can focus on your business.",
  },
  {
    title: "Premium standards",
    desc: "Every touchpoint reflects quality and attention to detail. We never cut corners.",
  },
  {
    title: "Industry breadth",
    desc: "Events, digital, social, interior fit-out, construction, fashion, and beauty under one roof.",
  },
  {
    title: "Long-term partnership",
    desc: "We grow with you, adapting our support as your brand evolves.",
  },
];

export default function WhyChooseUsPreview() {
  return (
    <section className="py-20 md:py-28 bg-aura-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="Why Choose Us"
          title="The Aura difference"
          subtitle="We bring a unique combination of expertise, standards, and commitment to every project."
        />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {points.map((item, i) => (
            <ScrollReveal key={item.title} delay={i * 0.08}>
              <div className="p-6 rounded-sm border border-gold-muted/20 bg-gold-light/5 hover:border-gold-primary/25 transition-colors h-full flex flex-col">
                <span className="inline-flex w-10 h-10 rounded-sm bg-gold-primary/20 text-gold-dark font-serif text-lg font-semibold items-center justify-center self-start">
                  {i + 1}
                </span>
                <h3 className="mt-4 font-serif text-lg font-semibold text-aura-text">
                  {item.title}
                </h3>
                <p className="mt-2 font-sans text-sm text-aura-text/90 leading-relaxed flex-1">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-12 text-center"
        >
          <Button to="/about" variant="outline">
            Learn More About Us
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
